import { render, staticRenderFns } from "./WizardComboBox.vue?vue&type=template&id=27720fb6"
import script from "./WizardComboBox.vue?vue&type=script&lang=ts"
export * from "./WizardComboBox.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports